import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthProvider";
import { postLogin } from "../../../services/Auth";
import Button from "../button/Button";
import TextInput from "../input/TextInput";

const FormLogin = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const [error, setError] = useState("");

  const initialState = {
    nif: "",
    password: "",
  };

  const [formData, setFormData] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await postLogin({ nif: formData.nif, password: formData.password });
      setAuth({
        user: data.user,
        token: data.access_token,
      });
      navigate("/");
    } catch (e) {
      console.log(e);
      setError(e.response.data.detail);
    }
  };

  const cancelOnClick = () => {
    navigate("/");
  };
  const handleReset = () => {
    setFormData(initialState);
  };

  return (
    <form id="login-form" className="space-y-4" onSubmit={handleSubmit} onReset={handleReset}>
      {error && <p className="text-red-500 text-sm">{error}</p>}
      <div className="space-y-4">
        <TextInput
          id="nif"
          type="text"
          placeholder="Nif"
          onChange={handleChange}
          autoComplete="username"
          value={formData.nif}
        />
        <TextInput
          id="password"
          type="password"
          placeholder="Password"
          onChange={handleChange}
          autoComplete="password"
          value={formData.password}
        />
      </div>
      <div className="space-y-2">
        <Button
          className="w-full bg-blue-700 text-white text-xs hover:bg-blue-900 font-bold py-1 px-3 rounded-md shadow-sm transition-colors"
          type="submit"
          onClick={handleSubmit}
        >
          LOGIN
        </Button>
        <Button
          className="w-full bg-gray-400 text-white text-xs hover:bg-gray-500 font-bold py-1 px-3 rounded-md shadow-sm transition-colors"
          type="cancel"
          onClick={cancelOnClick}
        >
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default FormLogin;
